import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { faExternalLinkAlt } from '@fortawesome/pro-light-svg-icons';
import { Linking, Platform, Text, View } from 'react-native';
import { useFontAwesomeIcon } from './platform';
export const InlineLink = React.memo(function InlineLink(props) {
    const FontAwesomeIcon = useFontAwesomeIcon();
    if (Platform.OS === 'web') {
        return (_jsx("a", { href: props.href, target: "_blank", rel: "noreferrer", children: _jsxs("div", { style: {
                    display: 'inline-block',
                    color: '#0798f2',
                    cursor: 'pointer',
                }, children: [props.label ?? props.href, ' ', _jsx("div", { style: {
                            display: 'inline-block',
                            fontSize: '0.8em',
                            paddingTop: '0.1em',
                            verticalAlign: 'top',
                        }, children: _jsx(FontAwesomeIcon, { icon: faExternalLinkAlt }) })] }) }));
    }
    else {
        return (_jsxs(Text, { onPress: () => Linking.openURL(props.href), children: [_jsx(Text, { style: { color: '#0798f2' }, children: props.label ?? props.href }), _jsx(View, { style: {
                        paddingLeft: 5,
                        height: props.fontSize,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'flex-end',
                    }, children: _jsx(FontAwesomeIcon, { icon: faExternalLinkAlt, size: props.fontSize * 0.8, color: "#0798f2" }) })] }));
    }
});
